import getCurrentTomorrowDates from './get-current-tomorrow-dates';

/**
 * @description given an iso date string, provides some parseable details about the date
 *
 * @param {string} isoDateString - iso date string
 * @returns {{ isToday: string, isTomorrow: boolean, isValidDate: boolean }} - calculated details about specific date
 */
var calculateDayOrDate = function calculateDayOrDate(isoDateString) {
  var _getCurrentTomorrowDa = getCurrentTomorrowDates(),
    todayDate = _getCurrentTomorrowDa.todayDate,
    tomorrowDate = _getCurrentTomorrowDa.tomorrowDate;
  var dateObject = isoDateString ? new Date(isoDateString) : null;
  var validDate = dateObject && (dateObject === null || dateObject === void 0 ? void 0 : dateObject.getDate());
  return {
    isToday: validDate === (todayDate === null || todayDate === void 0 ? void 0 : todayDate.getDate()),
    isTomorrow: validDate === (tomorrowDate === null || tomorrowDate === void 0 ? void 0 : tomorrowDate.getDate()),
    isValidDate: Boolean(validDate)
  };
};
export default calculateDayOrDate;